import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createSelectors } from './utils';

interface WorkflowsState {
  lastWorkflowId: string | null;
  lastVersionId: string | null;
  setLastVisited: (workflowId?: string | null, versionId?: string | null) => void;
}

const useWorkflowsStoreBase = create<WorkflowsState>()(
  persist(
    (set) => ({
      lastWorkflowId: null,
      lastVersionId: null,
      setLastVisited: (workflowId, versionId) =>
        set({
          lastWorkflowId: workflowId ?? null,
          lastVersionId: versionId ?? null,
        }),
    }),
    {
      name: 'pt-workflows',
    },
  ),
);

export const useWorkflowsStore = createSelectors(useWorkflowsStoreBase);
